{
  "assets-deeplinking-modal.closeButton": [
    {
      "type": 0,
      "value": "Close"
    }
  ],
  "assets-deeplinking-modal.description1": [
    {
      "type": 0,
      "value": "You can now click directly on data points in your charts to drill in and see the underlying records. For example, if you select a bar in the “Ticket volume” chart, we’ll open a detailed view showing the actual tickets that make up that data point."
    }
  ],
  "assets-deeplinking-modal.description2": [
    {
      "type": 0,
      "value": "This lets you move from high-level trends to the raw sources behind them in just one click."
    }
  ],
  "assets-deeplinking-modal.doneButton": [
    {
      "type": 0,
      "value": "Done"
    }
  ],
  "assets-deeplinking-modal.heading": [
    {
      "type": 0,
      "value": "See the data behind your charts"
    }
  ]
}